export default function replaceFrenchAccents(frenchString: string): string {
  return frenchString.normalize('NFD').replace(/\p{Diacritic}/gu, '');
}

export function hasDiacritics(value: string): boolean {
  return replaceFrenchAccents(value) !== value;
}

export function namesMatchIgnoringAccents(left: string, right: string): boolean {
  return replaceFrenchAccents(left).toLowerCase() === replaceFrenchAccents(right).toLowerCase();
}

/**
 * When two strings name the same place and differ only by accents, keep the
 * accented spelling. Does not invent accents — the accented form must already
 * be present on `candidate`.
 */
export function preferAccentedText(candidate: string, current: string): string {
  if (!candidate) return current;
  if (!current) return candidate;
  if (!namesMatchIgnoringAccents(candidate, current)) return current;
  if (hasDiacritics(candidate) && !hasDiacritics(current)) return candidate;
  return current;
}
